import React, {useContext} from 'react'
import {AppContext} from '../app/app'
import {deselectAllShips} from '../ship/utils'

import './score.css'

const Score = () => {
    const {
        config,
        setModalContentType,
        toggleGameOverOverlay,
        toggleModal,
    } = useContext(AppContext)
    const {gameStats} = config
    const collectedArtifacts = Object.keys(config.artifacts).filter(
        (key) => config.artifacts[key].isCollected
    ).length

    const handleClick = (modalContentType) => {
        deselectAllShips()
        toggleGameOverOverlay(false)
        setModalContentType(modalContentType)
        toggleModal()
    }

    return (
        <div className="score">
            <div className="score__item" onClick={() => handleClick('score')}>
                <img
                    alt="score"
                    className="score__icon"
                    src={`${process.env.PUBLIC_URL}/img/score.png`}
                />
                {gameStats.score && gameStats.score.toLocaleString()}
            </div>
            <div
                className="score__item score__item--resources"
                onClick={() => handleClick('resources')}
            >
                <img
                    alt="resources"
                    className="score__icon"
                    src={`${process.env.PUBLIC_URL}/img/resources-green.png`}
                />
                {gameStats.resources && gameStats.resources.toLocaleString()}
            </div>
            <div
                className="score__item score__item--artifacts"
                onClick={() => handleClick('artifacts')}
            >
                <img
                    alt="artifacts"
                    className="score__icon"
                    src={`${process.env.PUBLIC_URL}/img/artifact-white.png`}
                />
                {collectedArtifacts}/{Object.keys(config.artifacts).length}
            </div>
        </div>
    )
}

export default Score
